// extracted by mini-css-extract-plugin
export default {"wrapper":"Keynotes_wrapper__X7h4F","container":"Keynotes_container__QSi64"};